import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as Icons from 'components/Utils/Icons'

const ENTER = 13
const TAB = 9
const DOWN = 40
const UP = 38

class SearchBox extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onMoveDown: PropTypes.func.isRequired,
    onMoveUp: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }

  onInputChange = event => this.props.onChange(event.target.value)

  onKeyDown = event => {
    if (event.keyCode === ENTER) {
      event.preventDefault()
      this.props.onEnter()
    }

    if (event.keyCode === UP) {
      event.preventDefault()
      this.props.onMoveUp()
    }
    if (event.keyCode === DOWN || event.keyCode === TAB) {
      event.preventDefault()
      this.props.onMoveDown()
    }
  }

  render() {
    const { value } = this.props
    return (
      <div className="flexbox flexbox-align-center border-bottom-small border-shade-40 padding-left-small padding-right-normal">
        <Icons.SearchIcon
          size={12}
          className="flexbox-no-grow shade-30 margin-left-small"
        />
        <input
          type="text"
          className={classNames(
            [
              'flexbox-grow',
              'width-full border-none',
              'padding-vertical-normal padding-left-medium',
              'font-size-normal font-weight-medium',
              'background-transparent',
              'placeholder-shade-30 shade-05',
            ],
            {}
          )}
          autoFocus
          tabIndex={-1}
          placeholder={'Find a template...'}
          onKeyDown={this.onKeyDown}
          onChange={this.onInputChange}
          value={value}
        />
      </div>
    )
  }
}

export default SearchBox
